import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { meta, permissions } from 'helpers/decorators'
import { apiCommon, apiContacts, apiTranslationsManagement } from 'helpers/decorators/api'
import {
  DeleteParticipantAward,
  MergeParticipantAccounts,
  RecalculateMetrics,
  RecoverDeletedParticipant,
  UploadTranslation,
} from 'containers/forms/support'
import { Title } from '../../../components/layout'
import { connect } from 'react-redux'
import { modal } from '../../../redux/modules/app'
import { get } from 'lodash'
import ChangeAwardMode from '../../forms/support/ChangeAwardMode/ChangeAwardMode'
import { Announcements } from '../../forms/support'


const enhance = compose(
  meta({
    title: 'Support',
    intlKey: 'pageTitle.support'
  }),
    apiContacts({
        active: true
    }),
  apiCommon({ locales: true }),
  apiTranslationsManagement(),
  permissions(),
    connect(
        ({ api }) => ({
            activeContact: api.contacts.active
        }),
        { modal }
    )
)

class SupportPage extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onUpdateTranslations: PropTypes.func,
    onCloseDialog: PropTypes.func,
    isUpdateInProgress: PropTypes.bool,
    permissions: PropTypes.object.isRequired,
    activeContact: PropTypes.object.isRequired,
  }

  render() {
      const { permissions: appPermissions, activeContact } = this.props

      const editCustomizationEnabled = get(activeContact, 'editCustomizationEnabled')

      const allroles = appPermissions.isIf || appPermissions.isGbt || appPermissions.isNaoStaff || appPermissions.isIfRegion

      const superUserWithoutRegion = appPermissions.isIf && !appPermissions.isIfRegion

      if (allroles && editCustomizationEnabled) {
          return (
              <div>
                  {allroles && <MergeParticipantAccounts {...this.props} />}
                  {(appPermissions.isIf || appPermissions.isGbt || appPermissions.isIfRegion) && <RecoverDeletedParticipant {...this.props} />}
                  {allroles && <DeleteParticipantAward {...this.props} />}
                  {allroles && <ChangeAwardMode {...this.props} />}
                  {superUserWithoutRegion && <UploadTranslation {...this.props} />}
                  {superUserWithoutRegion && <RecalculateMetrics {...this.props} />}
                  {superUserWithoutRegion && <Announcements {...this.props} />}
              </div>
          )
      } else {
          return (
              <div>
                  <Title h2 intlKey="moduleTitle.forbidden">
                      Forbidden
                  </Title>
              </div>
          )
      }
  }
}

export default enhance(SupportPage)
